import getURLParameter from '../common/getURLParameter'
import arrayShuffle from '../common/array-shuffle'

let { modelObj: { type = '' } = {} } = {
    modelObj: window.__modelObj
}

let { city = '' } = getURLParameter(),
    hotWord = []

export const renderHotWord = () => {
    $('.searchBox .hotSearch .hotList > ul').html(`
		${arrayShuffle(hotWord)
            .map(
                ({ name = '热搜标签', url = 'javascript:void(0)' } = {}) => `
			<li><a class="clickreport-luna-search" href="${url}" data-tag="lunasearch-hot-2">${name}</a></li>
		`
            )
            .join('')}
	`)
}
export const initSearchHotWord = () => {
    $.ajax({
        type: 'get',
        url: '/api/gethottag',
        data: {
            type,
            city
        },
        dataType: 'json',
        success: ({ data = [] } = {}) => {
            hotWord = data
            renderHotWord()
        }
    })
}
